import { queryBuilder } from '~/api';

/**
 * Upload the overview image for a facility that commit just created. Sent separately
 * from commit because the image lives only in client memory until the facility row
 * exists; the server stores it as `facility<id>.png` in the images bucket.
 */
export const postOnboardingFacilityImage = async ({
  facilityId,
  file,
}: {
  facilityId: number;
  file: File;
}): Promise<void> => {
  await queryBuilder(
    'POST',
    `onboarding/facilities/${facilityId}/image`,
    undefined,
    {},
    [{ id: 0, fileName: file.name, fileType: file.type, file }]
  );
};
